/**
 * ###################
 * ###################
 * ###################
 * ###################
 * ### DEPRECIATED ###
 * ###################
 * ###################
 * ###################
 * ###################
 */


import $ from "jquery"
import { trace } from "./helpers.js"

const BluimpExtend = {
  
  initBluimpDescriptions() { 
    console.log("bluimp extend") 
    $('.blueimp-gallery').each( (index, el)=> {
      let $gallery = $(el);
      let $textWrapper = $gallery.find('.description');
      let selector = '#' + $gallery.attr("id");
      let $listLinks = $('a[data-gallery="' + selector + '"]');      
      $("body").on('slide', selector, (e, index, slide)=> {
        let $link = $listLinks.eq(index);
        let text = $link.data("description");        
        $textWrapper.html(text);
        if (text) {
          $textWrapper.addClass("active");
        } else {
          $textWrapper.removeClass("active");
        }
      });
    });
  },

  init() {
    this.initBluimpDescriptions();
  }


}

export default BluimpExtend;